import React from "react";
import styled from "styled-components";
import chroma from "chroma-js";
import _ from "lodash";
import { DragSource } from "react-dnd";
import { observer } from "mobx-react";

import * as Colors from "../reusable/colors";
import { Divider, HCenter } from "../reusable/layout";
import { ItemTypes } from "../constants/elements";
import { PropTypeToElem } from "./store";
import { icons } from "../catalog/element";
import { dbJS } from "./store";

const boxSource = {
  beginDrag(props, monitor) {
    return props.customProps || {};
  },
  endDrag(props, monitor) {},
  canDrag(props, monitor) {
    return true;
  }
};

function collect(connect, monitor) {
  return { connectDragSource: connect.dragSource(), isDragging: monitor.isDragging() };
}

const List = styled.ul`
  background-color: ${Colors.primary};
  width: 100px;
  text-align: center;
  position: relative;
`;

const AppearList = styled.ul`
  background-color: ${Colors.primary};
  width: 100px;
  text-align: center;
  left: 100px;
  top: 0;
  display: none;
  position: absolute;
  min-height: 100%;
`;

const Item = styled.div`
  padding: 10px;
  display: flex;
  ${HCenter};
  width: 100%;
  &:hover > ul {
    display: block;
  }
  &:hover > div {
    background-color: ${chroma(Colors.primary)
      .darken(0.6)
      .hex()};
  }
`;

const Element = styled.div`
  border: 1px black solid;
  border-radius: 4px;
  width: 100%;
  padding: 4px;
  display: flex;
  align-items: center;
  flex-direction: column;
  cursor: ${p => (p.draggable ? "grab" : "default")};
`;

const Pic = styled.div`
  height: 15px;
  width: 15px;
`;

const Leaf = ({ connectDragSource, elementType, name }) => {
  const Icon = icons[elementType];
  return connectDragSource(
    <div style={{ cursor: "-webkit-grab", width: "100%" }}>
      <Element draggable>
        {name}
        <Divider h="3px" />
        <Pic>
          <Icon />
        </Pic>
      </Element>
    </div>
  );
};

const DLeaf = DragSource(props => props.elementType, boxSource, collect)(Leaf);

const links = {
  [ItemTypes.ELEMENT_IMAGE]: "url",
  [ItemTypes.ELEMENT_TEXT]: "text",
  [ItemTypes.ELEMENT_EMPTYCONTAINER]: "collection",
  [ItemTypes.ELEMENT_PROGRESSBAR]: "progress"
};

const valueFns = {
  [ItemTypes.ELEMENT_IMAGE]: (entity, prop) => `{${entity}.${prop}}`,
  [ItemTypes.ELEMENT_TEXT]: (entity, prop) => `{${entity}.${prop}}`,
  [ItemTypes.ELEMENT_PROGRESSBAR]: (entity, prop) => ({ target: `${entity}.${prop}` }),
  [ItemTypes.ELEMENT_EMPTYCONTAINER]: (entity, prop) => `${entity}.${prop}`
};

const customProps = (entity, prop, type, value) => {
  return {
    [links[type]]: valueFns[type](entity, prop),
    ...(type === ItemTypes.ELEMENT_IMAGE ? { resolvedUrl: value } : {})
  };
};

const listProps = (spreadsheet, items) => {
  return spreadsheet[Object.keys(items)[0]] && spreadsheet[Object.keys(items)[0]].props;
};

const linkProps = (spreadsheet, link) => {
  return spreadsheet[link] && spreadsheet[link].props;
};

const getProps = type => {
  return {
    list: listProps,
    link: linkProps
  }[type];
};

const renderElements = (spreadsheet, data, parent) => {
  return _.map(data, (v, k) => (
    <Item key={k}>
      {PropTypeToElem[v.type] ? (
        <DLeaf
          key={k}
          name={k}
          elementType={PropTypeToElem[v.type]}
          customProps={customProps(parent, k, PropTypeToElem[v.type], v.value)}>
          {k}
        </DLeaf>
      ) : (
        <Element>{_.capitalize(k)}</Element>
      )}
      {(v.props || getProps(v.type)) && (
        <AppearList>
          {renderElements(
            spreadsheet,
            getProps(v.type) ? getProps(v.type)(spreadsheet, v.value) : v.props,
            parent ? parent + "." + k : k
          )}
        </AppearList>
      )}
    </Item>
  ));
};

export default observer(() => {
  return <List>{renderElements(dbJS.get(), _.omitBy(dbJS.get(), i => i.hidden))}</List>;
});



// WEBPACK FOOTER //
// ./src/spreadsheet/tree.js